import React from "react"
import {FeedEntityType, GroupCelebration, Poll, Recognition, RecognitionFeedComment} from "@irati/types"
import authentication from "@irati/auth"
import RecognitionService from "@irati/recognition/services/Recognition"
import {LIKE_REACTION} from "@irati/recognition/enums/Reactions"
import {IconTypes} from "@irati/ui/src/Icon"
import id from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"
import tracking from "@irati-tracking/recognition/shared"
import {stopPropagationAndPrevent} from "@irati-web/wallet/src/utils/stopBubbleEvent"
import IconWithNumber from "../Icons/IconWithNumber"
import Tooltip, {Tip} from "../shared/Tooltip"
interface LikeButtonProps {
  parent: Recognition | Poll | RecognitionFeedComment | GroupCelebration
  type: FeedEntityType
  id?: string
}
const LikeButton = (props: LikeButtonProps) => {
  const {parent, type} = props
  const likeReactions = parent.reactions?.results?.filter(({emoji}) => emoji?.code === LIKE_REACTION.code)
  const userLikeReaction = likeReactions?.find(({createdBy}) => createdBy?.uuid === authentication.user().uuid)
  const onLike = (ev: MouseEvent) => {
    stopPropagationAndPrevent(ev)
    if (!userLikeReaction) {
      tracking.clickLikeButton(parent, type)
    }
    RecognitionService.toggleLike(parent, type)
  }
  return (
    <Tooltip
      placement="bottom"
      tip={
        <Tip id={id("toolTip", props)}>
          <FormattedMessage id="recognition.like.tooltip" />
        </Tip>
      }>
      <span>
        <IconWithNumber
          id={id("likeIconWithNumber", props)}
          number={likeReactions?.length || 0}
          active={!!userLikeReaction}
          icon={IconTypes.thumbsUp}
          onClick={onLike}></IconWithNumber>
      </span>
    </Tooltip>
  )
}
export default LikeButton
